import React, { useEffect, useState } from "react";
import { useI18n } from "../context/I18nContext";
import { Button } from "./ui/button";
import { DeviceMobile } from "@phosphor-icons/react";

export const InstallPWA = ({ className = "" }) => {
  const { t } = useI18n();
  const [prompt, setPrompt] = useState(null);
  useEffect(() => {
    const handler = (e) => { e.preventDefault(); setPrompt(e); };
    window.addEventListener("beforeinstallprompt", handler);
    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);
  if (!prompt) return null;
  const install = async () => {
    prompt.prompt();
    try { await prompt.userChoice; } catch (e) { /* ignore */ }
    setPrompt(null);
  };
  return (
    <Button data-testid="install-pwa-btn" onClick={install} variant="outline" className={`h-12 px-6 text-base border-emerald-300 text-emerald-800 hover:bg-emerald-50 gap-2 ${className}`}>
      <DeviceMobile size={18} weight="bold" /> {t("install_app")}
    </Button>
  );
};
